import { gql } from "@apollo/client";

export const SearchImportAssets = gql`
    query SearchImportAssets (
        $filter: SearchAssetFilter
        $query: SearchAssetQuery
        $pagination: Pagination
        $sort: Sort
    ) {
        searchAssets(
            filter: $filter
            query: $query
        ) {
            total
            searchAssetResults (pagination: $pagination, sort: $sort) {
                attributes {
                    title
                }
                asset {
                    id
                    serialNumber
                    product {
                        id
                        name
                    }
                    manufacturer {
                        id
                        name
                    }
                    assetLocationImport {
                        id
                        insert
                        status
                    }
                }
                assetLocation {
                    id
                    installedBaseNode {
                        id
                        pathNodes {
                            id
                            title
                        }
                    }
                    owner {
                        id
                        name
                    }
                }
            }
        }
    }
`;
